export default {
  // ProcedureEvidenceView
  editEvidence: 'Editar Evidencia de Desempeño',
  deleteEvidenceConfirmation: '¿Está seguro de que desea eliminar la Evidencia de Desempeño?',
  evidenceDeleted: 'Evidencia de Desempeño eliminada.',

  // ProcedureEvidenceForm
  evidenceCreated: 'Evidencia de Desempeño creada.',
  evidenceUpdated: 'Evidencia de Desempeño actualizada.',
}
